//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const NonLiveTextboxes: FeatureFlag = {"Id":"NonLiveTextboxes","Label":"Delay calculations and validations until user leaves textual inputs","Impact":"Calculations update on blur instead of on type","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
